<template>
  <a-drawer :wrapClassName='$store.state.bgLight ? "lightColor" : ""' :title="title" :width="1024" placement="right"
            :closable="true" @close="close" :visible="visible">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-row :gutter="24">

          <a-col :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业全称">
              <a-input
                placeholder="请输入企业全称"
                v-decorator="['companyName', validatorRules.companyName]"
                :disabled="disableSubmit"
              />
            </a-form-item>
          </a-col>

          <a-col :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="组织机构代码">
              <a-input
                placeholder="请输入组织机构代码"
                v-decorator="['companyCode', validatorRules.companyCode]"
                :disabled="disableSubmit"
              />
            </a-form-item>
          </a-col>

          <a-col :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="统一社会信用代码">
              <a-input
                placeholder="请输入统一社会信用代码"
                v-decorator="['creditCode', validatorRules.creditCode]"
                :disabled="disableSubmit"
              />
            </a-form-item>
          </a-col>

          <a-col :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业类别">
              <j-dict-select-tag
                :triggerChange="true"
                :defaultState="true"
                dictCode="company_type"
                v-decorator="['type', validatorRules.type]"
                placeholder="请选择企业类别"
                :disabled="disableSubmit"
              >
              </j-dict-select-tag>
            </a-form-item>
          </a-col>

          <a-col :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="管理属性">
              <j-dict-select-tag
                :triggerChange="true"
                :defaultState="true"
                dictCode="management_attribute"
                v-decorator="['managementAttribute', {}]"
                placeholder="请选择管理属性"
                :disabled="disableSubmit"
              >
              </j-dict-select-tag>
            </a-form-item>
          </a-col>

          <a-col :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业规模">
              <j-dict-select-tag
                :triggerChange="true"
                :defaultState="true"
                dictCode="company_scale"
                v-decorator="['companyScale', {}]"
                placeholder="请选择企业规模"
                :disabled="disableSubmit"
              >
              </j-dict-select-tag>
            </a-form-item>
          </a-col>

          <a-col :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否重点污染源">
              <j-dict-select-tag
                :triggerChange="true"
                :defaultState="true"
                dictCode="yes_no_status"
                v-decorator="['keyPollutionSource', {}]"
                placeholder="请选择"
                :disabled="disableSubmit"
              >
              </j-dict-select-tag>
            </a-form-item>
          </a-col>

          <a-col :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="行政区域">
              <a-input placeholder="请输入行政区域" v-decorator="['administrativeDivision', {}]" :disabled="disableSubmit"/>
            </a-form-item>
          </a-col>

          <a-col :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="所属行业">
              <a-input placeholder="请输入所属行业" v-decorator="['industry', {}]" :disabled="disableSubmit"/>
            </a-form-item>
          </a-col>


          <a-col :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="法人代表">
              <a-input placeholder="请输入法人代表" v-decorator="['legalPerson', validatorRules.legalPerson]"
                       :disabled="disableSubmit"/>
            </a-form-item>
          </a-col>

          <a-col :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="官网">
              <a-input placeholder="请输入官网" v-decorator="['website', {}]" :disabled="disableSubmit"/>
            </a-form-item>
          </a-col>

          <a-col :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系人">
              <a-input placeholder="请输入联系人" v-decorator="['contact', validatorRules.contact]"
                       :disabled="disableSubmit"/>
            </a-form-item>
          </a-col>

          <a-col :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系人电话">
              <a-input
                placeholder="请输入联系人电话"
                v-decorator="['contactTel', validatorRules.contactTel]"
                :disabled="disableSubmit"
              />
            </a-form-item>
          </a-col>

          <a-col :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="成立日期">
              <a-date-picker ref="sDate" v-decorator="['sDate', {}]" :disabled="disableSubmit"/>
            </a-form-item>
          </a-col>

          <a-col :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="营业期限">
              <a-input placeholder="请输入营业期限" v-decorator="['businessTerm', {}]" :disabled="disableSubmit"/>
            </a-form-item>
          </a-col>

          <a-col :md="24" :sm="24">
            <a-form-item :labelCol="{ span: 4 }" :wrapperCol="{ span: 20 }" label="经营范围">
              <a-textarea
                :rows="2"
                placeholder="请输入经营范围"
                v-decorator="['businessScope', {}]"
                :disabled="disableSubmit"
              />
            </a-form-item>
          </a-col>

          <a-col :md="24" :sm="24">
            <a-form-item :labelCol="{ span: 4 }" :wrapperCol="{ span: 20 }" label="详细地址">
              <a-textarea
                :rows="2"
                placeholder="请输入经营范围"
                v-decorator="['address', {}]"
                :disabled="disableSubmit"
              />
            </a-form-item>
          </a-col>

          <a-col :md="24" :sm="24">
            <a-form-item :labelCol="{ span: 4 }" :wrapperCol="{ span: 20 }" label="备注">
              <a-textarea :rows="2" placeholder="请输入备注" v-decorator="['remark', {}]" :disabled="disableSubmit"/>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row style='margin-top: 10px'>
          <a-col>
            <iws-upload
              ref='iwupload'
              :options="{ btnText: '上传' }"
              :disableSubmit='disableSubmit'
              filesrc='site_company'
              :srcid='this.model.id'
            >
            </iws-upload>
          </a-col>
        </a-row>

        <div class="drawer-msg" v-show="disableSubmit">
          <a-row>
            <a-col :span="12"> 创建信息：{{ model.createBy_userName }} （{{ model.createTime }}）</a-col>
            <a-col :span="12"> 最后修改信息：{{ model.updateBy_userName }} （{{ model.updateTime }}）</a-col>
          </a-row>
        </div>
      </a-form>
    </a-spin>
    <div class="drawer-tool" v-show="!disableSubmit">
      <a-button icon="close" @click="handleCancel">取消</a-button>
      <a-button type="primary" :disabled="!networkStatus" icon="check" @click="handleOk">确定</a-button>
    </div>
  </a-drawer>
</template>

<script>
import {ModalFormMixin} from '@/mixins/ModalFormMixin'
import IwsUpload from '@comp/upload/IwsUpload'
import {httpAction} from '@api/manage'

import pick from "lodash.pick";
import moment from "moment/moment";

export default {
  name: 'CompanyModal',
  mixins: [ModalFormMixin],
  components: {
    IwsUpload,
  },
  data() {
    return {
      title: '表单',
      tableName: 'site_company',
      form_fields: [
        'companyName',
        'companyCode',
        'businessScope',
        'creditCode',
        'type',
        'managementAttribute',
        'companyScale',
        'keyPollutionSource',
        'administrativeDivision',
        'industry',
        'address',
        'legalPerson',
        'website',
        'contact',
        'contactTel',
        'businessTerm',
        'remark',
        'sort',
        'tenantId'
      ],
      form_fields_time: ['sDate'],
      validatorRules: {
        companyName: {rules: [{required: true, message: '请输入企业全称!'}]},
        companyCode: {rules: [{required: true, message: '请输入组织机构代码!'}]},
        legalPerson: {rules: [{required: true, message: '请输入法定代表人!'}]},
        contact: {rules: [{required: true, message: '请输入联系人!'}]},
        contactTel: {rules: [{required: true, message: '请输入联系人电话!'}]}
      }
    }
  },
  props: ['pagePath'],
  created() {
  },
  methods: {

    add() {
      this.edit({})
    },

    edit(record) {
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.visible = true
      this.$nextTick(() => {
        var that = this
        //debugger
        that.form.setFieldsValue(pick(that.model, that.form_fields))
        that.form.setFieldsValue({ sDate: this.model.sDate ? moment(this.model.sDate) : null })
        this.$refs.iwupload.loadUploadFiles()
      })

    },

    handleOk() {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          let formData = Object.assign(that.model, values)
          formData = this.$refs.iwupload.getUploadListToFromData(formData)
          let httpurl = '', method = ''
          if (!this.model.id) {
            httpurl = this.url.add ? this.url.add : this.pagePath
            method = 'post'
          } else {
            httpurl = this.url.edit ? this.url.edit : this.pagePath
            method = 'put'
          }
          httpAction(httpurl, formData, method).then((res) => {
            if (res.success) {
              this.$refs.iwupload.resetUploadFiles()
              that.$notification.success({message: res.message})
              that.$emit('ok')
              that.close()
            } else {
              that.$notification.warning({message: res.message})
            }
          }).finally(() => {
            that.confirmLoading = false
          })
        }
      })
    },

    handleCancel() {
      this.close()
    }


  }
}
</script>

<style scoped>
@import '~@assets/less/common.less';
</style>
